export default "__VITE_ASSET__DtBkrIKH__"